
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/policy_data_provision",
      function () {
        return require("private-next-pages/terms/policy_data_provision.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/policy_data_provision"])
      });
    }
  